import { Popover } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ComponentProps } from "react";

import { UserSection } from "../shared/user-section/UserSection";
import { MobilePopoverHeader } from "./MobilePopoverHeader";
import { MobilePopoverLinks } from "./NavigationSection";

export const MobilePopover = (props: ComponentProps<typeof Popover>) => (
  <Popover {...props}>
    {({ open }) => (
      <>
        <Popover.Button
          className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
          aria-label="open mobile menu"
        >
          {open ? (
            <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
          ) : (
            <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
          )}
        </Popover.Button>
        <Popover.Overlay className="fixed inset-0 z-10 bg-black/30" />
        {open && (
          <Popover.Panel className="fixed inset-0 z-20 xl:hidden">
            {({ close }) => (
              <div
                role="menu"
                className="absolute inset-2 flex flex-col justify-between overflow-scroll rounded-lg bg-white pt-4 shadow-lg scrollbar-hide"
                aria-label="mobile menu"
              >
                <div>
                  <MobilePopoverHeader close={close} />
                  <MobilePopoverLinks close={close} />
                </div>
                <div>
                  <div className="border-t border-zinc-200" />
                  <UserSection close={close} className="py-1" />
                </div>
              </div>
            )}
          </Popover.Panel>
        )}
      </>
    )}
  </Popover>
);
